import "./RecoupTime.module.css";
import Header from "@/reusable_sections/Header";
import Testimonials from "./sections/Testimonials";
import WeFindYourHiddenHours from "./sections/WeFindYourHiddenHours";
import TheOliviaExperience from "./sections/TheOliviaExperience";
import HowItWorks from "./sections/HowItWorks";
import WhatYouGet from "./sections/WhatYouGet";
import TheInvestment from "./sections/TheInvestment";
import SecureYourAssessment from "./sections/SecureYourAssessment";
import Footer from "@/reusable_sections/Footer";
export default function RecoupTimePage() {
  return <div>
      <Header />
      <WeFindYourHiddenHours />
      <TheOliviaExperience />
      <HowItWorks />
      <WhatYouGet />
      <TheInvestment />
      <Testimonials />
      <SecureYourAssessment />
      <Footer />
    </div>;
}